import React, { useState } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import SummaryWrapper from "./Summary.style";
import SummaryDetailTop from "../../components/summaryDetailTop/summarydetailtop";
import { getPaymentById, verifyTamaraOrder } from "../../../../services/renewal-service";
import { useNavigate } from "react-router-dom";
import config from "../../helpers/renewal.config";
import * as globalUtils from "../../../../helpers/utils";
import HomeInsurancePromoMsg from "../../../../_shared/HomeInsurancePromoMsg/HomeInsurancePromoMsg";

const Summary = (props) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [policy, setPolicy] = useState("");
  let tamara = {};
  let checkout = null;
  try {
    tamara = JSON.parse(localStorage.getItem("tamaraResponse"));
  } catch (error) {
    console.error("Empty Tamara Object");
  }
  try {
    checkout = JSON.parse(localStorage.getItem("checkoutId"));
  } catch (error) {
    console.error("Empty checkout Id");
  }

  if (checkout && !policy) {
    getPaymentById(checkout).then((response) => {
      const res = response.data;
      if (res.resultCode === "S") {
        setPolicy(res.policyNo);
      } else {
        !policy && (window.location.href = config.paymentFailedRedirect);
      }
    });
  } else if (checkout && !policy) {
      const data = {
        "systemId":"MOTOR",
        "applicationType":"RHSP",
        "langCode": globalUtils.getOneLetterLanguageCode(props.i18n.language),
        "referenceId": tamara.refId,
        "channelCode":"85"
    }
    verifyTamaraOrder(data).then((response) => {
        const res = response.data.verifyOrderResponse;
        if (res.resultCode === "S") {
          setPolicy(res.policyNumber);
        } else {
          !policy && (window.location.href = config.paymentFailedRedirect);
        }
      });
  } else {
    !policy && (window.location.href = config.paymentFailedRedirect);
  }

  return (
    <SummaryWrapper>
      <div className="Summary-wrapper">
        <div className="summary-top-section col-12">
          <SummaryDetailTop policy={policy} />
        </div>
        {/* <HomeInsurancePromoMsg text={t('HomeInsurancePromoMsg')}/> */}
        <div className="vehical-section col-12"></div>
      </div>
    </SummaryWrapper>
  );
};
//export default withTranslation()(connect(Summary));
export default withTranslation()(Summary);
